import { getOrgConfig } from "../Common/Hooks/OrgConfigHooks";
import { Navigate } from "react-router-dom";

import Dashboard from "../pages/Dashboard";
import Intents from "../pages/Intents";
// import Insights from "../pages/Insights";
import InsightsIncomeVsExpense from "../pages/Insights/IncomeVsExpense";
import InsightsExpenses from "../pages/Insights/Expenses";
import InsightsIncomes from "../pages/Insights/Incomes";
import InsightsTax from "../pages/Insights/Tax";
import Cashflow from "../pages/Cashflow";
import OrgSettings from "../pages/OrgSettings";

import Signin from "../pages/Authentication/login";
import Logout from "../pages/Authentication/logout";
import UserProfile from "../pages/Authentication/user-profile";
import Register from "../pages/Authentication/register";
import CompaniesList from "../pages/CompaniesList";
import PersonsList from "../pages/PersonsList";
import CategoriesList from "../pages/CategoriesList";
import TagsList from "../pages/TagsList";
import TagRulesList from "../pages/TagRulesList";
import ProjectsList from "../pages/ProjectsList";
import ProjectDetailsView from "../pages/ProjectDetailsView";
import ProjectTypesList from "../pages/ProjectTypesList";
import PagesUserProfile from "../pages/UserProfile";
import DownloadDBBackup from "../pages/DownloadDBBackup";
import StatementImport from "../pages/StatementImport";
import PasswordReset from "../pages/AuthenticationInner/PasswordReset";
import PasswordCreate from "../pages/AuthenticationInner/PasswordCreate";

// Built at module scope, so the plain getter is used rather than the hook.
const orgConfig = getOrgConfig();

const authProtectedRoutes = [
  // DDV only exists for tax-enabled orgs; the "*" catch-all below absorbs
  // bookmarked deep links.
  ...(orgConfig.tax_enabled
    ? [{ path: "/insights/tax", component: <InsightsTax /> }]
    : []),

    { path: "/dashboard", component: <Dashboard /> },
    { path: "/intents", component: <Intents /> },
    { path: "/insights/income_expense", component: <InsightsIncomeVsExpense /> },
    { path: "/insights/expenses", component: <InsightsExpenses /> },
    { path: "/insights/incomes", component: <InsightsIncomes /> },
    { path: "/cashflow", component: <Cashflow /> },
    { path: "/import", component: <StatementImport /> },

    { path: "/companies", component: <CompaniesList /> },
    { path: "/persons", component: <PersonsList /> },
    { path: "/categories", component: <CategoriesList /> },
    { path: "/projects", component: <ProjectsList /> },
    { path: "/project/", component: <ProjectDetailsView /> },
    { path: "/project/:id", component: <ProjectDetailsView /> },
    { path: "/project_types", component: <ProjectTypesList /> },
    { path: "/tags", component: <TagsList /> },
    { path: "/tag_rules", component: <TagRulesList /> },

    { path: "/download_db_backup", component: <DownloadDBBackup /> },

    { path: "/", exact: true ,component: <Navigate to="/dashboard" /> },
    { path: "*", component: <Navigate to="/dashboard" /> },

    // user profile
    { path: "/org_settings", component: <OrgSettings /> },
    // { path: "/user-profile", component: <UserProfile /> },
    { path: "/users/:id", component: <PagesUserProfile /> },
    { path: "/create_user", component: <PagesUserProfile /> },

    { path: "/", component: <Dashboard /> },
    { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
    // Authentication
    { path: "/login", component: <Signin /> },
    { path: "/logout", component: <Logout /> },
    { path: "/register", component: <Register /> },
    { path: "/reset_passwd", component: <PasswordReset /> },
    { path: "/create_passwd/:token", component: <PasswordCreate /> },

]

export { publicRoutes, authProtectedRoutes };
